// PDP sticky purchase bar for agent-growth.
// The vendor component shows itself after the real product form has scrolled
// above the viewport. On tablet/mobile the purchase form can instead sit far
// below the first screen, so this file also exposes the sticky action while the
// form is below the viewport. It never duplicates the CTA while the real form
// is visible and it gets out of the way at the footer.
if (!window.dreissigackerKaufleiste) {
  window.dreissigackerKaufleiste = true;

  const KLASSE_SICHTBARER_KNOPF = 'kaufleiste--knopf-sichtbar';
  const KLASSE_VOR_KAUFBEREICH = 'kaufleiste--vor-kaufbereich';
  const MOBILE_TABLET = window.matchMedia('(max-width: 999px)');

  let beobachter = null;
  let frame = 0;

  const elemente = () => {
    const leiste = document.querySelector('product-sticky-add-to-cart');
    const bereich = leiste && document.getElementById(leiste.getAttribute('main-product-form'));
    const footer = document.querySelector('.shopify-section--footer');
    return { leiste, bereich, footer };
  };

  const pruefen = () => {
    const { leiste, bereich, footer } = elemente();
    if (!leiste) return;

    if (!bereich) {
      leiste.classList.remove(KLASSE_SICHTBARER_KNOPF, KLASSE_VOR_KAUFBEREICH);
      return;
    }

    const masse = bereich.getBoundingClientRect();
    const imBild = masse.bottom > 0 && masse.top < window.innerHeight;
    const unterhalb = masse.top >= window.innerHeight;

    let footerImBild = false;
    if (footer) {
      const footerMasse = footer.getBoundingClientRect();
      footerImBild = footerMasse.bottom > 0 && footerMasse.top < window.innerHeight;
    }

    leiste.classList.toggle(KLASSE_SICHTBARER_KNOPF, imBild);
    leiste.classList.toggle(
      KLASSE_VOR_KAUFBEREICH,
      MOBILE_TABLET.matches && unterhalb && !footerImBild
    );
  };

  const anmelden = () => {
    const { bereich, footer } = elemente();
    beobachter?.disconnect();
    beobachter = null;
    if (!bereich) return;

    beobachter = new IntersectionObserver(pruefen);
    beobachter.observe(bereich);
    if (footer) beobachter.observe(footer);
  };

  const pruefenImFrame = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      pruefen();
    });
  };

  const neuAnmelden = () => {
    requestAnimationFrame(() => {
      pruefen();
      anmelden();
    });
  };

  pruefen();
  anmelden();

  addEventListener('scroll', pruefenImFrame, { passive: true });
  addEventListener('resize', pruefenImFrame, { passive: true });
  addEventListener('pageshow', neuAnmelden);
  MOBILE_TABLET.addEventListener('change', pruefenImFrame);
  document.addEventListener('variant:change', neuAnmelden);
  document.addEventListener('shopify:section:load', neuAnmelden);
}
